import MobilePhotoWrapper from '../src/MobilePhotoWrapper';
export default MobilePhotoWrapper;
